module.exports = __webpack_public_path__ + "static/media/Snorkeling.6b9c8ac6.png";